import * as React from "react";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";
import { PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

interface CustomerNotificationsProps {
  location: CustomerNotificationLocation;
  page?: PageStore;
  className?: string;
}

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject("page")(
  (props: CustomerNotificationsProps) => {
    const { location, page, className = "all-b-margin-three" } = props;

    if (!page || !page.pageId) {
      return null;
    }

    return (
      <React.Fragment>
        <Experiment name={"SURFACE_Travel_Advisory_V2"}>
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <div className={className}>
              <CustomerNotification
                inputs={{
                  xPageId: page.pageId,
                  notificationLocation: location,
                }}
              />
            </div>
          </ExperimentVariant>
        </Experiment>
      </React.Fragment>
    );
  }
);
